import { useQuery } from '@apollo/client';

import { GET_MY_TEAMS } from '../queries/teams';

export const useMyTeams = () => {
  const { data, loading, error } = useQuery(GET_MY_TEAMS);

  return {
    teams: data?.teams || [],
    loading,
    error,
  };
};

export default useMyTeams;
